import PropTypes from 'prop-types';
import { Button } from '@ui-propulsion/react-components';
import parse from 'html-react-parser';
import { useEffect, useState } from 'react';
import styles from './ctaBanner.module.scss';
import handleCTAClick from '../../services/helpers/handleCTAClick';
import { ctaTheme } from '../../utils/util';

function CtaBanner({
  headline = '',
  description = '',
  offerText = '',
  cta = null,
  theme = 'darkBlue',
  isMediaCenter = true,
  config = {
    containerSize: null,
    headLine: {
      position: 'center',
    },
  },
}) {
  const [ctaThemes, setCtaThemes] = useState(styles.redSolid);

  useEffect(() => {
    setCtaThemes(ctaTheme(cta?.ctaTheme));
  }, [cta]);

  const headlineClass = config.headLine.position
    ? `${styles.ctaBannerTitle} ${styles[config.headLine.position]}`
    : styles.ctaBannerTitle;
  const containerClass = config.containerSize
    ? `${styles.ctaBanner} ${styles[config.containerSize]}`
    : styles.ctaBanner;

  return (
    <div className={containerClass}>
      <div
        className={`${styles.ctaBannerContent} ${
          theme === 'white' || theme === 'grey' || theme === 'homeHeading'
            ? styles.whiteTheme
            : styles.darkTheme
        } ${theme === 'homeHeading' && styles.homeHeadingTheme}`}
      >
        {offerText && (
          <div className={styles.ctaBannerOfferText}>{offerText}</div>
        )}
        {headline && isMediaCenter ? (
          <h1 className={headlineClass}>{parse(headline)}</h1>
        ) : (
          headline && <h2 className={headlineClass}>{parse(headline)}</h2>
        )}
        {description && (
          <p className={styles.ctaBannerText}>{parse(description)}</p>
        )}
        {cta && (
          <div className={styles.getStartedBtn}>
            <Button
              id="apply_online_cta"
              data-testid="apply_online_cta"
              className={`${styles.getStartedCta} ${ctaThemes}`}
              variant="tertiary"
              type="button"
              onClick={(e) => handleCTAClick(e, cta)}
              href={cta?.link}
            >
              {cta.label}
            </Button>
          </div>
        )}
      </div>
    </div>
  );
}
export default CtaBanner;

CtaBanner.propTypes = {
  headline: PropTypes.string,
  description: PropTypes.string,
  offerText: PropTypes.string,
  cta: PropTypes.shape({
    label: PropTypes.string,
    link: PropTypes.string,
  }),
  theme: PropTypes.string,
  isMediaCenter: PropTypes.bool,
  config: PropTypes.shape({
    containerSize: PropTypes.oneOf([null, 'medium', 'small']),
    headLine: PropTypes.shape({
      position: PropTypes.oneOf([null, 'left', 'center', 'right']),
    }),
  }),
};
